'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_Inputs$InputType() {
}
export { $c_Lpresto_ui_Inputs$InputType as $c_Lpresto_ui_Inputs$InputType };
$p = $c_Lpresto_ui_Inputs$InputType.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_Inputs$InputType;
/** @constructor */
function $h_Lpresto_ui_Inputs$InputType() {
}
export { $h_Lpresto_ui_Inputs$InputType as $h_Lpresto_ui_Inputs$InputType };
$h_Lpresto_ui_Inputs$InputType.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=presto.ui.-Inputs$-Input-Type.js.map
